// 本地测试环境 登录host
// export const BASE_URL = "";
// export const BASE_SHARE_URL = "https://ylddy.bjd.com.cn/"
//测试环境
// export const BASE_URL = "https://ylddytest.bjd.com.cn/";
// export const BASE_SHARE_URL = "https://ylddytestapi.bjd.com.cn/"
//正式环境
export const BASE_URL = "https://ylddyapi.bjd.com.cn/";
export const BASE_SHARE_URL = "https://ylddy.bjd.com.cn/"